const months = [
    'محرم',
    'صفر',
    'ربيع الأول',
    'ربيع الثاني',
    'جمادى الأولى',
    'جمادى الآخرة',
    'رجب',
    'شعبان',
    'رمضان',
    'شوال',
    'ذو القعدة',
    'ذو الحجة'
]

const monthsShort = [
    'محرم',
    'صفر',
    'ربيع 1',
    'ربيع 2',
    'جمادى 1',
    'جمادى 2',
    'رجب',
    'شعبان',
    'رمضان',
    'شوال',
    'القعدة',
    'الحجة'
]

export default {
    name: 'ar_hijri',
    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
    months,
    monthsShort,
    week: {
        dow: 5
    }
}
